(function(){
    'use strict', 
    angular.module('Services').service('ThirdPartyAccountingAppsTable', ThirdPartyAccountingAppsTable); 
    ThirdPartyAccountingAppsTable.$inject = [
        'TableLiteFactory',
        'AccountingService',
        'toastr',
        '$location'
    ]; 

    function ThirdPartyAccountingAppsTable(
        TableLiteFactory,
        AccountingService,
        toastr,
        $location
    ){
        return function(filterParams = {}){
            const tableData = {
                tableName: 'ThirdPartyAccouintingAppsTable', 
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    colMinWidth: '135px'
                },
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add new accounting app',
                        tooltip: 'Click to add new accounting app',
                        onClick: function () {
                            $location.path('/api-access/accounting-app-details/new');
                        }
                    }]
                },
                headers: [{
                    label: 'Accounting App Name',
                    viewName: 'appId',
                    filterName: 'appId',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Customer', 
                    viewName: 'customer', 
                    filterName: 'customer', 
                    filter: {
                        type: 'text', 
                        placeholder: 'Search', 
                        onSubmit: function(header){
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    }, 
                    headerFn: function(){
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Actions', 
                    viewName: 'actions', 
                    class: 'text-center',
                    width: '100px'
                }],
                data: [],
                onInit: ()=>{
                    tableActions.sendRequest({});
                }
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.CustomerAccountingApps.getAll, 
                callbackFormat: ['success', 'error', 'filter'], 
                postRequestCallback: data=>{
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null); 
                    toastr.error(err.message, "Error");
                }, 
                defaultFilters: angular.extend({
                    size:20, 
                    page: 0, 
                    sort: 'appId,desc'
                }, filterParams)
            });

            function buildTableData(data){
                if(!data) { return tableData; }
                
                tableActions.initializeTableData(data); 
                angular.forEach(data.content, (item) => {
                    item.customer = item.customer.name || 'N/A';
                    item.actions = {
                        type: 'button', 
                        buttons: [{
                            text: angular.getObjVal(item, 'customer') ? 'View' : 'Connect', 
                            icon: '', 
                            class: 'btn-primary', 
                            action: (data) => {
                                $location.path(`/api-access/accounting-app-details/${data.id}`);
                            }
                        }]
                    }; 
                    tableData.data.push(item);
                });
            }

            this.tableData = tableData;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/api-access-tables/ThirdPartyAccountingAppTableService.js